import { render, staticRenderFns } from "./VerNotas.vue?vue&type=template&id=a4d8083e&scoped=true"
import script from "./VerNotas.vue?vue&type=script&lang=js"
export * from "./VerNotas.vue?vue&type=script&lang=js"
import style0 from "./VerNotas.vue?vue&type=style&index=0&id=a4d8083e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d8083e",
  null
  
)

export default component.exports